// extracted by mini-css-extract-plugin
export default {"buttons":"QYa0Dlg3X94PKVUbBWtL","placeHolderShimmer":"pb0q3ioVIqCCoaTYwWRg"};